export const ENDPOINT = 'api/get-delivery-merchants';

export type RateAndTime = {
  delivery_value: number; // valor da entrega
  time: number; // tempo estimado de entrega em minutos
  is_active: boolean; // indica se o valor/tempo está ativo para o km
  km: number; // distância em quilômetros
};

/**
 * Representa um estabelecimento retornado pela API de busca de estabelecimentos.
 */
export type Store = {
  id: string; // identificador único do estabelecimento
  name: string; // nome do estabelecimento
  description: string; // descrição do estabelecimento
  image: string; // identificador ou URL da imagem do estabelecimento
  rating: string; // avaliação do estabelecimento (string, ex: "5")
  avgRating: string; // avaliação média do estabelecimento (string, ex: "0")
  delivery_time: string; // tempo estimado de entrega (string, ex: "5")
  delivery_time_max: string | null; // tempo máximo de entrega (pode ser nulo)
  price_range: string; // faixa de preço do estabelecimento (string, ex: "5")
  slug: string; // slug do estabelecimento (ex: "servidao-lanches")
  is_featured: number; // indica se o estabelecimento é destaque (0 ou 1)
  is_open: boolean; // indica se o estabelecimento está aberto
  distance: number; // distância do usuário até o estabelecimento em km (ex: 0.10)
  custom_featured_name: string | null; // nome personalizado para destaque (pode ser nulo)
  custom_message_on_list: string | null; // mensagem personalizada na listagem (pode ser nulo)
  rate_and_time?: RateAndTime[]; // lista de faixas de entrega por km (opcional)
  min_order_price: string; // valor mínimo do pedido (ex: "13.50")
  delivery_charge: number; // taxa de entrega
};

/**
 * Representa a solicitação de busca de estabelecimentos.
 */
export type GetStoresRequest = {
  latitude: string; // latitude do usuário
  longitude: string; // longitude do usuário
};

/**
 * Resposta da busca de estabelecimentos: lista de estabelecimentos.
 */
export type GetStoresResponse = Store[];
